const SpinnerVuexModule = {
    namespaced: true,
    state: {
        callers: []
    },
    getters: {
        visible: state => state.callers.length > 0
    },
    mutations: {
        addCaller: (state, caller) => {
            state.callers.push(caller);
        },
        removeCaller: (state, caller) => {
            state.callers = state.callers.filter(c => c !== caller);
        },
        removeAll: state => {
            state.callers = [];
        },
    },
    actions: {
        needSpinner: context => {
            let token = {};
            context.commit('addCaller', token);
            return token;
        },
        dontNeedSpinner: (context, token) => {
            context.commit('removeCaller', token);
        },
    },
}

export default SpinnerVuexModule;
